import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Types as ProductsTypes } from '../../../../../actions/products'
import { Metrics } from '../../../../../constants/Dashboards'
import { Product } from '../../../../products'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { InteractionsProductPayload, InteractionsProducts } from '../../types'

/**
 * Large Vision Interactions Per Product reducer
 */
const largeVisionInteractionsPerProduct = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_INTERACTIONS_PRODUCTS,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT.failure,
    },
    transform: (state, { payload }): InteractionsProducts => {
        const typedPayload = (payload as InteractionsProductPayload[]) || []
        const playlistMap: Record<string, number> = typedPayload.reduce(
            (carry, { product, count }) => ({
                ...carry,
                [product]: count,
            }),
            {}
        )
        const sortedPlaylistsList: string[] = Object.keys(playlistMap).sort((a: string, b: string): number => playlistMap[b] - playlistMap[a])

        return {
            values: sortedPlaylistsList.map((p) => playlistMap[p]),
            labels: sortedPlaylistsList,
            total: sortedPlaylistsList.length,
            perc: null,
            name: 'dashboard-count-interactions',
        }
    },
})

/**
 * Large Vision Interactions Per Product reducer
 */
const largeVisionProductDetails = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_INTERACTIONS_PRODUCTS,
    types: {
        request: ProductsTypes.DCG_PRODUCT_INFORMATION.request,
        success: ProductsTypes.DCG_PRODUCT_INFORMATION.success,
        failure: ProductsTypes.DCG_PRODUCT_INFORMATION.failure,
    },
    transform: (state: any, { payload, meta }): InteractionsProducts | undefined => {
        if (meta.secondaryType !== LargeVisionActionTypes.DASHBOARD_LARGEVISION_INTERACTIONS_PRODUCT.success) {
            return
        }

        const products: Product[] = payload?.data?.getProducts || []
        const { stats } = state
        const data: InteractionsProducts = stats[Metrics.LARGEVISION_INTERACTIONS_PRODUCTS]

        if (!data) {
            return
        }

        const oldDataLabels: string[] = data.labels
        const newDataLabels: string[] = oldDataLabels.map((sku: string): string => {
            const productData: Product | undefined = products.find((product: Product): boolean => {
                console.log(product)
                return product?.sku === sku
            })

            if (productData) {
                const title: string = productData.title.en_gb
                return `${sku} ${title}`
            }

            return sku
        })

        return {
            ...data,
            labels: newDataLabels,
        }
    },
})

export default largeVisionInteractionsPerProduct

export { largeVisionProductDetails }
